// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  msUniversalDateFormat: 'MM/dd/yyyy',
  msUniversalDateTimeFormat: 'MM/dd/yyyy hh:mm a',
  msUniversalDateTimeWithSecondsFormat: 'MM/dd/yyyy hh:mm:ss TT',
  IPAddressURL: 'https://api.ipify.org/?format=json',
    WebApiURL: 'https://pilotbird-claim-prod-api.pilotbird.com/',
    veriskSSOUrl: 'https://sso.verisk.com/authorize', // Verisk SSO authorization endpoint
    veriskSignOutUrl: '/logout', // Verisk-registered Sign-Out URL - handles redirect after IdP logout
    // Security hotfix HF-01.2 (FE-1): public OAuth client ids (not secrets) for Google and Microsoft sign-in.
    // Before HF-02 they came from api/Config/GetEncryptedKey (key names googleClientId and microsoftClientId);
    // paste this environment's values here. They must equal the API's ExternalLoginSettings:GoogleClientId and
    // ExternalLoginSettings:MicrosoftClientId. Empty disables that sign-in button.
    googleClientId: '',
    microsoftClientId: ''
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
